import React from 'react';
import { X } from 'lucide-react';
import { EngagementForm } from './EngagementForm';
import { useEngagements } from '../../hooks/useEngagements';
import { useAuth } from '../../contexts/AuthContext';

interface AddEngagementPopupProps {
  onClose: () => void;
  onSuccess: () => void;
}

export default function AddEngagementPopup({ onClose, onSuccess }: AddEngagementPopupProps) {
  const { createEngagement } = useEngagements();
  const { user } = useAuth();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-dark-800 rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Add New Engagement</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <EngagementForm 
          onSubmit={async (data) => {
            console.log('AddEngagementPopup - Form submitted with data:', data);
            
            if (!user) {
              console.error('AddEngagementPopup - No user found');
              return;
            }
            
            console.log('AddEngagementPopup - User ID:', user.id);
            
            try {
              const engagementData = {
                ...data,
                user_id: user.id,
                status: 'draft' as const
              };
              console.log('AddEngagementPopup - Attempting to create engagement with:', engagementData);
              
              const result = await createEngagement(engagementData);
              console.log('AddEngagementPopup - Create engagement result:', result);
              
              await onSuccess();
              console.log('AddEngagementPopup - Success callback completed');
              
              onClose();
              console.log('AddEngagementPopup - Modal closed');
            } catch (err) {
              console.error('AddEngagementPopup - Failed to create engagement:', err);
              if (err instanceof Error) {
                console.error('AddEngagementPopup - Error details:', {
                  message: err.message,
                  stack: err.stack
                });
              }
            }
          }}
          onCancel={onClose}
        />
      </div>
    </div>
  );
}
